import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './types'
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        user: {},
        token: null
    },
    mutations: {
        [types.LOGIN]: (state, data) => {
            document.cookie='token'+'='+'Bearer '+data.access_token+';max-age'+'='+data.expires_in+';path=/';
            state.token = 'Bearer '+data.access_token;
        },
        [types.LOGIN_IN]: (state, data) => {
            state.token = data;
        },
        [types.LOGOUT]: (state) => {
            document.cookie='token'+'='+''+';path=/';
            state.token = null;
            location.reload() 
        },
        [types.USER]: (state, data) => {
            state.user = data;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js